import { AuthorityService } from './services/authority/authority.service';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppAuthService } from './services/auth/app-auth.service';
import { MaintenanceMenuService } from './shared/maintenance-menu/maintenance-menu.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  isIframe = false;
  public isLogined = false;

  constructor(
    public maintenanceMenuService: MaintenanceMenuService,
    private authorityService: AuthorityService,
    private auth: AppAuthService,
    private titleObj: Title) { }

  /** 初期化イベント */
  ngOnInit() {
    let title = this.titleObj.getTitle();
    title = title.replace('{0}', environment.organization);
    this.titleObj.setTitle(title);
    this.auth.loginChanged.subscribe(status => {
      // すでにログイン状態だったら何もしない
      if (!status || this.isLogined) {
        return;
      }

      this.initlaize();
    });

    this.initlaize();
  }

  /** 初期化処理 */
  private async initlaize() {
    const login = await this.auth.loginStatus();
    console.log(Date.now(), 'initlaize', login);
    if (!login) {
      this.auth.login();
      return;
    }
    this.isLogined = true;

    const org = environment.organization;
    const id = await this.auth.userId();

    this.authorityService.getAuthority(org, id);

  }

  /**
   * メニュー表示
   */
  public showMenu() {
    this.maintenanceMenuService.showMenu();
  }
}
